module.exports = XMLHttpRequest
